import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/Button";

const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

// Mismo componente en cualquier tabla paginada del panel — nunca scroll infinito. `total` es el
// número de filas que cumplen el filtro actual (no el total de la tabla entera). `limit`/
// `onLimitChange` son opcionales: si no se pasan, no se muestra el selector de "por página" (p.ej.
// en listados que no dejan elegir cuántos se ven).
export function Pagination({
  page,
  totalPages,
  total,
  onPageChange,
  limit,
  onLimitChange,
}: {
  page: number;
  totalPages: number;
  total: number;
  onPageChange: (page: number) => void;
  limit?: number;
  onLimitChange?: (limit: number) => void;
}) {
  if (total === 0) return null;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-2 py-1">
      <p className="text-xs text-ink-400">
        Página {page} de {totalPages} — {total} en total
      </p>
      <div className="flex flex-wrap items-center gap-3">
        {onLimitChange && (
          <label className="flex items-center gap-1.5 text-xs text-ink-400">
            Por página
            <select
              value={limit}
              onChange={(e) => onLimitChange(Number(e.target.value))}
              className="rounded-lg border border-ink-100 bg-white px-2 py-1 text-xs outline-none transition focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
            >
              {PAGE_SIZE_OPTIONS.map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </label>
        )}
        <div className="flex gap-2">
          <Button disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
            <ChevronLeft className="h-4 w-4" />
            Anterior
          </Button>
          <Button disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>
            Siguiente
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
